
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("f788Q", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $513b3aabfa44d17f$export$2cd8252107eb640b; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $9jv6U = parcelRequire("9jv6U");

var $01JF1 = parcelRequire("01JF1");

var $cGDYS = parcelRequire("cGDYS");

var $7RyUO = parcelRequire("7RyUO");

var $dunoe = parcelRequire("dunoe");

var $k2OeR = parcelRequire("k2OeR");

var $j0nzO = parcelRequire("j0nzO");

var $jpi63 = parcelRequire("jpi63");

var $6wlNh = parcelRequire("6wlNh");

var $9uFWm = parcelRequire("9uFWm");

var $EyEcw = parcelRequire("EyEcw");

var $9Dbz6 = parcelRequire("9Dbz6");
window.BUILD_KEY = "p-7ba311c62e";
window.featureGateBootstrapValues = window.featureGateBootstrapValues || {
    identifiers: {
        analyticsAnonymousId: (0, $cGDYS.default)()
    }
};
const $513b3aabfa44d17f$var$BASE_URL = "https://www.atlassian.com";
const $513b3aabfa44d17f$var$SUPPORTED_LOCALES = [
    {
        hrefLang: "ja",
        langRoute: "ja"
    },
    {
        hrefLang: "fr",
        langRoute: "fr"
    },
    {
        hrefLang: "de",
        langRoute: "de"
    },
    {
        hrefLang: "es",
        langRoute: "es"
    },
    {
        hrefLang: "pt-BR",
        langRoute: "br"
    },
    {
        hrefLang: "zh-Hans",
        langRoute: "zh"
    },
    {
        hrefLang: "ko",
        langRoute: "ko"
    },
    {
        hrefLang: "ru",
        langRoute: "ru"
    },
    {
        hrefLang: "pl",
        langRoute: "pl"
    },
    {
        hrefLang: "it",
        langRoute: "it"
    },
    {
        hrefLang: "nl",
        langRoute: "nl"
    }
];
const $513b3aabfa44d17f$export$2cd8252107eb640b = (Component)=>{
    const isStatic = typeof window !== "undefined" && window.IS_STATIC;
    const analyticsWebClient = (0, $dunoe.getAnalyticsWebClient)();
    const { locale: locale, path: path } = (0, $9Dbz6.parseRoute)(window.location);
    const route = path !== "" ? "/" + path : "";
    // Get location data for experiments and feature gates from server-provided data
    let locationData;
    // Use server-provided data (no client-side API calls)
    if (typeof window !== "undefined") locationData = {
        countryIsoCode: window.countryCode || "",
        regionIsoCode: window.regionIsoCode || ""
    };
    const isPerfOnetrustEnabled = (0, $k2OeR.isPerformanceOnetrustEnabled)(typeof window !== "undefined" ? window.optanonConsentCookie : (0, $k2OeR.extractOptanonConsentCookie)(document.cookie), locationData);
    isPerfOnetrustEnabled && (0, $7RyUO.initUFO)(analyticsWebClient, path);
    const parsedClientCookies = document.cookie ? (0, $9jv6U.parse)(document.cookie) : {};
    const userAgent = typeof window !== "undefined" ? window.navigator.userAgent : "";
    const { finalExperimentOverrides: finalExperimentOverrides, finalFeatureGateOverrides: finalFeatureGateOverrides } = (0, $EyEcw.processExperimentAndFeatureGateOverrides)(parsedClientCookies, userAgent, isPerfOnetrustEnabled);
    // Below is for debugging edge - will be removed
    window.ssrAnonId = window.featureGateBootstrapValues.identifiers.analyticsAnonymousId;
    // We can't feature gate below code as this is done before initialization so just overriding for the path we are testing
    if ((0, $6wlNh.isEdgeCachingPath)(window.location.pathname)) {
        // Override for Edge Caching
        (0, $6wlNh.overrideAjsAnonIdFromCookie)();
        (0, $6wlNh.overrideCustomAttributes)();
    }
    (0, $j0nzO.initializeFeatureGatesClient)(window.featureGateBootstrapValues, {
        overrideValues: {
            experimentOverrides: finalExperimentOverrides,
            featureGateOverrides: finalFeatureGateOverrides
        },
        // if performance cookies are disabled, we will skip exposures
        localMode: !isPerfOnetrustEnabled
    }).then(()=>{
        const page = /*#__PURE__*/ (0, $loA2J.jsxs)((0, $9uFWm.SentryIntlProvider), {
            locale: locale,
            messages: window.SSR_languagePack,
            cookies: document.cookie,
            children: [
                isStatic && /*#__PURE__*/ (0, $loA2J.jsx)("link", {
                    rel: "canonical",
                    href: `${$513b3aabfa44d17f$var$BASE_URL}${route}`
                }),
                isStatic && /*#__PURE__*/ (0, $loA2J.jsx)("link", {
                    rel: "alternate",
                    href: `${$513b3aabfa44d17f$var$BASE_URL}${route}`,
                    hrefLang: "x-default"
                }),
                isStatic && $513b3aabfa44d17f$var$SUPPORTED_LOCALES.map(({ hrefLang: hrefLang, langRoute: langRoute })=>/*#__PURE__*/ (0, $loA2J.jsx)("link", {
                        rel: "alternate",
                        href: `${$513b3aabfa44d17f$var$BASE_URL}/${langRoute}${route}`,
                        hrefLang: hrefLang
                    }, hrefLang)),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $jpi63.PageWrapper), {
                    analyticsWebClient: analyticsWebClient,
                    location: window.location,
                    pricing: window.prices,
                    availableProducts: window.availableProducts,
                    userProfile: window.userProfile,
                    userProfileStatus: window.userProfileStatus,
                    userContext: window.userContext,
                    userContextStatus: window.userContextStatus,
                    loggedOutContext: window.loggedOutContext,
                    loggedOutContextStatus: window.loggedOutContextStatus,
                    loggedInContext: window.loggedInContext,
                    loggedInContextStatus: window.loggedInContextStatus,
                    countryCode: window.countryCode,
                    templates: window.templates,
                    partnerTemplates: window.partnerTemplates,
                    collections: window.collections,
                    categories: window.categories,
                    composition: window._uniformPreloadedComposition,
                    isUniformPlayground: window.isUniformPlayground,
                    isAllowPostMessage: window.isAllowPostMessage,
                    teamType: window.teamType,
                    keyword: window.keyword,
                    referrer: window.referrer,
                    mlTemplateIds: window.mlTemplateIds,
                    track: window.track,
                    anchor: window.anchor,
                    subAnchor: window.subAnchor,
                    auxiaResponse: window.auxiaResponse,
                    PageComponent: Component,
                    transactionAccounts: window.transactionAccounts,
                    userAgent: userAgent,
                    clusterTag: window.clusterTag
                })
            ]
        });
        if (isStatic) {
            // @ts-ignore
            const root = (0, $01JF1.createRoot)(document.getElementById("wac"));
            root.render(page);
        } else (0, $01JF1.hydrateRoot)(// @ts-ignore
        document.getElementById("wac-root"), page, {
            onRecoverableError: (error, errorInfo)=>{
                var _document_getElementById;
                (_document_getElementById = document.getElementById("wac-root")) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.setAttribute("hydration-error", "true");
            }
        });
    });
};

});

parcelRegister("4vcv5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::55c6484ab5ceb86b7f950bb9205e88a3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3473c0fe0e2991b1$var$_react = $3473c0fe0e2991b1$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $3473c0fe0e2991b1$var$_baseNew = $3473c0fe0e2991b1$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $3473c0fe0e2991b1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3473c0fe0e2991b1$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $3473c0fe0e2991b1$var$_react.default.createElement($3473c0fe0e2991b1$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$3473c0fe0e2991b1$var$ChevronDownIcon.displayName = "ChevronDownIcon";
var $3473c0fe0e2991b1$var$_default = module.exports.default = $3473c0fe0e2991b1$var$ChevronDownIcon;

});

parcelRegister("9HFEq", function(module, exports) {

$parcel$export(module.exports, "Card", function () { return (parcelRequire("dbhgV")).Card; });
$parcel$export(module.exports, "default", function () { return (parcelRequire("dbhgV")).Card; });

var $dbhgV = parcelRequire("dbhgV");

});
parcelRegister("dbhgV", function(module, exports) {

$parcel$export(module.exports, "Card", function () { return $1d73d5771cc6d344$export$60332b2344f7fe41; });
/* card.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable local/ensure-wac-token-usage */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $ix9oc = parcelRequire("ix9oc");
const $1d73d5771cc6d344$var$containerStyles = null;
const $1d73d5771cc6d344$var$contentBlockStyles = null;
const $1d73d5771cc6d344$var$barStyles = null; /**
                         * @deprecated - Please use @/libraries/design/components/card instead
                         */ 
const $1d73d5771cc6d344$export$60332b2344f7fe41 = (props)=>{
    const { textColor: textColor, headerType: headerType, headerText: headerText, bodyText: bodyText, eyebrowText: eyebrowText, footerHeader: footerHeader, footerText: footerText, imageLink: imageLink, imageAltText: imageAltText, backgroundColor: backgroundColor, colorBars: colorBars, iconName: iconName, iconColor: iconColor, iconSize: iconSize, barColor: barColor = "", className: className, ctaProps: ctaProps, aspectRatio: aspectRatio, orientation: orientation, pictureProps: pictureProps, clickableCardUrl: clickableCardUrl } = props;
    if (imageLink && !imageAltText) throw new Error("If using an image, please provide an alt text for accessibility purposes!");
    const cardBackBackgroundColor = backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : "#ffffff";
    const cardBackTextColor = textColor !== null && textColor !== void 0 ? textColor : "#091e42";
    const cardBackColor = null;
    const contentBlockIconColor = iconColor !== null && iconColor !== void 0 ? iconColor : "#091e42";
    const handleClick = ()=>{
        if (clickableCardUrl) window.location.href = clickableCardUrl;
    };
    const clickableCardStyle = null;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_2rkoyh40 _16qs1nta _1e0c1txw _2lx21bp4 _p12fg505 _7cca15wb _4t3i1osq",
            "_bfhk16d1 _syazn54i",
            "_80om1wzl",
            className
        ]),
        onClick: handleClick,
        style: {
            "--_1vkwvj7": (0, $43MIc.default)(cardBackBackgroundColor),
            "--_1dl5pj2": (0, $43MIc.default)(cardBackTextColor),
            "--_8vvi5m": (0, $43MIc.default)(clickableCardUrl ? "pointer" : "default")
        },
        children: [
            colorBars == "top" || colorBars == "both" ? /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                style: {
                    backgroundColor: barColor,
                    borderTopRightRadius: "4px",
                    borderTopLeftRadius: "4px"
                },
                className: (0, $esG4f.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq _4t3iftgi"
                ])
            }) : "",
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $ix9oc.ContentBlock), {
                cardStyle: true,
                aspectRatio: aspectRatio,
                orientation: orientation,
                headerType: headerType,
                headerText: headerText,
                bodyText: bodyText,
                imageLink: imageLink,
                imageAltText: imageAltText,
                eyebrowText: eyebrowText,
                footerHeader: footerHeader,
                footerText: footerText,
                iconColor: contentBlockIconColor,
                iconName: iconName,
                iconSize: iconSize,
                ctaProps: ctaProps,
                pictureProps: pictureProps,
                className: (0, $esG4f.default)([
                    "_4t3i1osq"
                ])
            }),
            colorBars == "bottom" || colorBars == "both" ? /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                style: {
                    backgroundColor: barColor,
                    borderBottomRightRadius: "4px",
                    borderBottomLeftRadius: "4px"
                },
                className: (0, $esG4f.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq _4t3iftgi"
                ])
            }) : ""
        ]
    });
};

});


parcelRegister("f0Hih", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("dhmEV")).default; });

var $dhmEV = parcelRequire("dhmEV");

});

parcelRegister("hGQlB", function(module, exports) {

$parcel$export(module.exports, "HelperMessage", function () { return $ce0ef700797d1e43$export$8fbe3c7d0ed2c683; });
$parcel$export(module.exports, "ErrorMessage", function () { return $ce0ef700797d1e43$export$915e9e7bd4f0f96d; });
/** @jsx jsx */ 
var $2ZUkg = parcelRequire("2ZUkg");

var $beKx6 = parcelRequire("beKx6");

var $ajAjT = parcelRequire("ajAjT");

var $i9mWg = parcelRequire("i9mWg");

var $eJftL = parcelRequire("eJftL");

var $gB0Pk = parcelRequire("gB0Pk");

var $1D2Zu = parcelRequire("1D2Zu");

var $8In0n = parcelRequire("8In0n");
/**
 * API for the internal `<Message />` component. This is not public API.
 */ /**
 * Public API of the various message components.
 */ var $ce0ef700797d1e43$var$fontFamily = (0, $gB0Pk.fontFamily)();
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var $ce0ef700797d1e43$var$lightH200Styles = (0, $2ZUkg.css)((0, $1D2Zu.h200)({
    theme: {
        mode: "light"
    }
}));
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var $ce0ef700797d1e43$var$darkH200Styles = (0, $2ZUkg.css)((0, $1D2Zu.h200)({
    theme: {
        mode: "dark"
    }
}));
var $ce0ef700797d1e43$var$messageStyles = (0, $2ZUkg.css)({
    display: "flex",
    marginTop: "var(--ds-space-050, 4px)",
    justifyContent: "baseline",
    fontFamily: "".concat($ce0ef700797d1e43$var$fontFamily),
    fontWeight: "normal"
});
var $ce0ef700797d1e43$var$messageAppearanceStyles = {
    default: (0, $2ZUkg.css)({
        color: "var(--ds-text-subtlest, ".concat((0, $i9mWg.N200), ")")
    }),
    error: (0, $2ZUkg.css)({
        color: "var(--ds-text-danger, #AE2A19)"
    }),
    valid: (0, $2ZUkg.css)({
        color: "var(--ds-text-success, #216E4E)"
    })
};
var $ce0ef700797d1e43$var$iconWrapperStyles = (0, $2ZUkg.css)({
    display: "flex"
});
var $ce0ef700797d1e43$var$IconWrapper = function IconWrapper(_ref) {
    var children = _ref.children;
    return (0, $2ZUkg.jsx)("span", {
        css: $ce0ef700797d1e43$var$iconWrapperStyles
    }, children);
};
var $ce0ef700797d1e43$var$messageIcons = {
    error: (0, $2ZUkg.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ajAjT))), {
        size: "small",
        label: "error"
    }),
    valid: (0, $2ZUkg.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($beKx6))), {
        size: "small",
        label: "success"
    })
};
var $ce0ef700797d1e43$var$Message = function Message(_ref2) {
    var children = _ref2.children, _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? "default" : _ref2$appearance, fieldId = _ref2.fieldId, testId = _ref2.testId;
    var _useGlobalTheme = (0, $eJftL.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    var icon = $ce0ef700797d1e43$var$messageIcons[appearance];
    /**
   * The wrapping span is necessary to preserve spaces between children.
   * Otherwise the flex layout of the message will remove any whitespace
   * between children.
   *
   * If the child is just a string, this is not required and we can use one
   * less DOM element.
   */ var content = typeof children === "string" ? children : (0, $2ZUkg.jsx)("span", null, children);
    return (0, $2ZUkg.jsx)("div", {
        css: [
            mode === "light" ? $ce0ef700797d1e43$var$lightH200Styles : $ce0ef700797d1e43$var$darkH200Styles,
            $ce0ef700797d1e43$var$messageStyles,
            $ce0ef700797d1e43$var$messageAppearanceStyles[appearance]
        ],
        "data-testid": testId,
        id: fieldId,
        "aria-live": "polite"
    }, icon && (0, $2ZUkg.jsx)($ce0ef700797d1e43$var$IconWrapper, null, icon), content);
};
var $ce0ef700797d1e43$export$8fbe3c7d0ed2c683 = function HelperMessage(_ref3) {
    var children = _ref3.children, testId = _ref3.testId;
    return (0, $2ZUkg.jsx)((0, $8In0n.FieldId).Consumer, null, function(fieldId) {
        return (0, $2ZUkg.jsx)($ce0ef700797d1e43$var$Message, {
            fieldId: fieldId ? "".concat(fieldId, "-helper") : undefined,
            testId: testId
        }, children);
    });
};
var $ce0ef700797d1e43$export$915e9e7bd4f0f96d = function ErrorMessage(_ref4) {
    var children = _ref4.children, testId = _ref4.testId;
    return (0, $2ZUkg.jsx)((0, $8In0n.FieldId).Consumer, null, function(fieldId) {
        return (0, $2ZUkg.jsx)($ce0ef700797d1e43$var$Message, {
            appearance: "error",
            fieldId: fieldId ? "".concat(fieldId, "-error") : undefined,
            testId: testId
        }, children);
    });
};
var $ce0ef700797d1e43$export$5505afb209a532c8 = function ValidMessage(_ref5) {
    var children = _ref5.children, testId = _ref5.testId;
    return (0, $2ZUkg.jsx)((0, $8In0n.FieldId).Consumer, null, function(fieldId) {
        return (0, $2ZUkg.jsx)($ce0ef700797d1e43$var$Message, {
            appearance: "valid",
            fieldId: fieldId ? "".concat(fieldId, "-valid") : undefined,
            testId: testId
        }, children);
    });
};

});
parcelRegister("beKx6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $82e518fdeb6fbfd5$var$_react = $82e518fdeb6fbfd5$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $7mqaz = parcelRequire("7mqaz");
function $82e518fdeb6fbfd5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $82e518fdeb6fbfd5$var$EditorSuccessIcon = (props)=>/*#__PURE__*/ $82e518fdeb6fbfd5$var$_react.default.createElement($7mqaz.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M12 20a8 8 0 110-16 8 8 0 010 16zm1.364-10.964l-2.152 4.11-1.543-1.39a1 1 0 10-1.338 1.487l2.5 2.25a1 1 0 001.555-.279l2.75-5.25a1 1 0 00-1.772-.928z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$82e518fdeb6fbfd5$var$EditorSuccessIcon.displayName = "EditorSuccessIcon";
var $82e518fdeb6fbfd5$var$_default = $82e518fdeb6fbfd5$var$EditorSuccessIcon;
module.exports.default = $82e518fdeb6fbfd5$var$_default;

});
parcelRegister("7mqaz", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $55bee3329526d280$export$f04a61298a47a40f; });

var $gBJBQ = parcelRequire("gBJBQ");

var $5YztE = parcelRequire("5YztE");

var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $eJftL = parcelRequire("eJftL");

var $hFg9K = parcelRequire("hFg9K");

var $C5UR5 = parcelRequire("C5UR5");
function $55bee3329526d280$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $55bee3329526d280$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $55bee3329526d280$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $5YztE.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $55bee3329526d280$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $55bee3329526d280$var$iconStyles = (0, $2ZUkg.css)({
    display: "inline-block",
    flexShrink: 0,
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    "> svg": $55bee3329526d280$var$_objectSpread($55bee3329526d280$var$_objectSpread({}, (0, $C5UR5.commonSVGStyles)), {}, {
        maxWidth: "100%",
        maxHeight: "100%",
        color: "var(--icon-primary-color)",
        fill: "var(--icon-secondary-color)",
        verticalAlign: "bottom"
    })
});
/**
 * For windows high contrast mode
 */ var $55bee3329526d280$var$baseHcmStyles = (0, $2ZUkg.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        "> svg": {
            filter: "grayscale(1)",
            "--icon-primary-color": "CanvasText",
            // foreground
            "--icon-secondary-color": "Canvas" // background
        }
    }
});
var $55bee3329526d280$var$primaryEqualsSecondaryHcmStyles = (0, $2ZUkg.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        "> svg": {
            // if the primaryColor is the same as the secondaryColor we
            // set the --icon-primary-color to Canvas
            // this is usually to convey state i.e. Checkbox checked -> not checked
            "--icon-primary-color": "Canvas" // foreground
        }
    }
});
var $55bee3329526d280$var$secondaryTransparentHcmStyles = (0, $2ZUkg.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        "> svg": {
            "--icon-secondary-color": "transparent" // background
        }
    }
});
var $55bee3329526d280$export$f04a61298a47a40f = /*#__PURE__*/ (0, $iSvIT.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? "currentColor" : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $2ZUkg.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    var dimensions = (0, $C5UR5.getIconSize)({
        width: width,
        height: height,
        size: size
    });
    var _useGlobalTheme = (0, $eJftL.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    return (0, $2ZUkg.jsx)("span", (0, $gBJBQ.default)({
        "data-testid": testId,
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            "--icon-primary-color": primaryColor,
            "--icon-secondary-color": secondaryColor || (0, $hFg9K.getBackground)(mode)
        }
    }, glyphProps, {
        css: [
            $55bee3329526d280$var$iconStyles,
            $55bee3329526d280$var$baseHcmStyles,
            primaryColor === secondaryColor && $55bee3329526d280$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === "transparent" && $55bee3329526d280$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsualting them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            (0, $2ZUkg.css)({
                width: dimensions.width,
                height: dimensions.height,
                "> svg": dimensions
            })
        ]
    }));
});
var $55bee3329526d280$export$2e2bcd8739ae039 = $55bee3329526d280$export$f04a61298a47a40f;

});
parcelRegister("gBJBQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c1737b1fc36c59f9$export$2e2bcd8739ae039; });
function $c1737b1fc36c59f9$export$2e2bcd8739ae039() {
    return $c1737b1fc36c59f9$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c1737b1fc36c59f9$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("hFg9K", function(module, exports) {

$parcel$export(module.exports, "getBackground", function () { return $cdc2cc4711baaf6c$export$18cb9425622d4e06; });
var $cdc2cc4711baaf6c$var$themedBackground = {
    light: "var(--ds-surface, #FFFFFF)",
    dark: "var(--ds-surface, #1B2638)"
};
var $cdc2cc4711baaf6c$export$18cb9425622d4e06 = function getBackground() {
    var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "light";
    return $cdc2cc4711baaf6c$var$themedBackground[mode];
};

});

parcelRegister("C5UR5", function(module, exports) {

$parcel$export(module.exports, "commonSVGStyles", function () { return $07282385e629ffb3$export$16374db1c3e6dfba; });
$parcel$export(module.exports, "getIconSize", function () { return $07282385e629ffb3$export$3eb7d6130acfda37; });

var $5GTS0 = parcelRequire("5GTS0");

var $2ZUkg = parcelRequire("2ZUkg");
var $07282385e629ffb3$export$16374db1c3e6dfba = {
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: "currentColor"
    }
};
var $07282385e629ffb3$var$smallStyles = (0, $2ZUkg.css)((0, $5GTS0.dimensions).small);
var $07282385e629ffb3$var$mediumStyles = (0, $2ZUkg.css)((0, $5GTS0.dimensions).medium);
var $07282385e629ffb3$var$largeStyles = (0, $2ZUkg.css)((0, $5GTS0.dimensions).large);
var $07282385e629ffb3$var$xlargeStyles = (0, $2ZUkg.css)((0, $5GTS0.dimensions).xlarge);
var $07282385e629ffb3$export$ef0ad74202575b64 = {
    small: $07282385e629ffb3$var$smallStyles,
    medium: $07282385e629ffb3$var$mediumStyles,
    large: $07282385e629ffb3$var$largeStyles,
    xlarge: $07282385e629ffb3$var$xlargeStyles
};
var $07282385e629ffb3$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $5GTS0.dimensions)[size];
    return undefined;
};

});
parcelRegister("5GTS0", function(module, exports) {

$parcel$export(module.exports, "dimensions", function () { return $424c36a103c23fbe$export$62ad7b0c781000e9; });
var $424c36a103c23fbe$export$c647cb0ee6e282fe = {
    small: "16px",
    medium: "24px",
    large: "32px",
    xlarge: "48px"
};
var $424c36a103c23fbe$export$7bd66fc94c81bf84 = {
    small: "small",
    medium: "medium",
    large: "large",
    xlarge: "xlarge"
};
var $424c36a103c23fbe$export$62ad7b0c781000e9 = {
    small: {
        width: $424c36a103c23fbe$export$c647cb0ee6e282fe.small,
        height: $424c36a103c23fbe$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $424c36a103c23fbe$export$c647cb0ee6e282fe.medium,
        height: $424c36a103c23fbe$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $424c36a103c23fbe$export$c647cb0ee6e282fe.large,
        height: $424c36a103c23fbe$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $424c36a103c23fbe$export$c647cb0ee6e282fe.xlarge,
        height: $424c36a103c23fbe$export$c647cb0ee6e282fe.xlarge
    }
};

});




parcelRegister("ajAjT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7827da129d8b6100$var$_react = $7827da129d8b6100$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $7mqaz = parcelRequire("7mqaz");
function $7827da129d8b6100$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $7827da129d8b6100$var$ErrorIcon = (props)=>/*#__PURE__*/ $7827da129d8b6100$var$_react.default.createElement($7mqaz.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path d="M13.416 4.417a2.002 2.002 0 00-2.832 0l-6.168 6.167a2.002 2.002 0 000 2.833l6.168 6.167a2.002 2.002 0 002.832 0l6.168-6.167a2.002 2.002 0 000-2.833l-6.168-6.167z" fill="currentColor"/><path d="M12 14a1 1 0 01-1-1V8a1 1 0 012 0v5a1 1 0 01-1 1m0 3a1 1 0 010-2 1 1 0 010 2" fill="inherit"/></g></svg>`
    }, props));
$7827da129d8b6100$var$ErrorIcon.displayName = "ErrorIcon";
var $7827da129d8b6100$var$_default = $7827da129d8b6100$var$ErrorIcon;
module.exports.default = $7827da129d8b6100$var$_default;

});


parcelRegister("gsk9h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bfaee3f31e759839$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $2ZUkg = parcelRequire("2ZUkg");

var $eJftL = parcelRequire("eJftL");

var $1D2Zu = parcelRequire("1D2Zu");
var $bfaee3f31e759839$var$formSectionDescriptionStyles = (0, $2ZUkg.css)({
    marginTop: "var(--ds-space-100, 8px)"
});
var $bfaee3f31e759839$var$formSectionTitleStyles = (0, $2ZUkg.css)({
    marginTop: 0,
    marginRight: "var(--ds-space-400, 32px)",
    lineHeight: "var(--ds-space-400, 32px)",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
});
var $bfaee3f31e759839$var$formSectionWrapperStyles = (0, $2ZUkg.css)({
    marginTop: "var(--ds-space-300, 24px)"
});
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var $bfaee3f31e759839$var$lightH600Styles = (0, $2ZUkg.css)((0, $1D2Zu.h600)({
    theme: {
        mode: "light"
    }
}));
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var $bfaee3f31e759839$var$darkH600Styles = (0, $2ZUkg.css)((0, $1D2Zu.h600)({
    theme: {
        mode: "dark"
    }
}));
var $bfaee3f31e759839$var$FormSectionWrapper = function FormSectionWrapper(_ref) {
    var children = _ref.children;
    return (0, $2ZUkg.jsx)("div", {
        css: $bfaee3f31e759839$var$formSectionWrapperStyles
    }, children);
};
var $bfaee3f31e759839$var$FormSectionTitle = function FormSectionTitle(_ref2) {
    var children = _ref2.children;
    var _useGlobalTheme = (0, $eJftL.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    return (0, $2ZUkg.jsx)("h3", {
        css: [
            $bfaee3f31e759839$var$formSectionTitleStyles,
            mode === "light" ? $bfaee3f31e759839$var$lightH600Styles : $bfaee3f31e759839$var$darkH600Styles
        ]
    }, children);
};
var $bfaee3f31e759839$var$FormSectionDescription = function FormSectionDescription(_ref3) {
    var children = _ref3.children;
    return (0, $2ZUkg.jsx)("div", {
        css: $bfaee3f31e759839$var$formSectionDescriptionStyles
    }, children);
};
/**
 * __Form section__
 *
 * A form section is used to define a section of a form layout. This contains a section title, content
 * and a description of the section.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 */ var $bfaee3f31e759839$var$FormSection = function FormSection(_ref4) {
    var children = _ref4.children, description = _ref4.description, title = _ref4.title;
    return (0, $2ZUkg.jsx)($bfaee3f31e759839$var$FormSectionWrapper, null, title && (0, $2ZUkg.jsx)($bfaee3f31e759839$var$FormSectionTitle, null, title), description && (0, $2ZUkg.jsx)($bfaee3f31e759839$var$FormSectionDescription, null, description), children);
};
var $bfaee3f31e759839$export$2e2bcd8739ae039 = $bfaee3f31e759839$var$FormSection;

});

parcelRegister("h6aNO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c72b60579b631d81$var$_react = $c72b60579b631d81$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $c72b60579b631d81$var$_chevronDown = $c72b60579b631d81$var$_interopRequireDefault((parcelRequire("4vcv5")));
function $c72b60579b631d81$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c72b60579b631d81$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $c72b60579b631d81$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8.292 10.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0"/></svg>`
    }, props, {
        newIcon: $c72b60579b631d81$var$_chevronDown.default
    }));
$c72b60579b631d81$var$ChevronDownIcon.displayName = "ChevronDownIcon";
var $c72b60579b631d81$var$_default = module.exports.default = $c72b60579b631d81$var$ChevronDownIcon;

});

parcelRegister("kG61r", function(module, exports) {

$parcel$export(module.exports, "ADG4CtaWithPolygonBackground", function () { return $86b2c7811891ac1f$export$eacf4ba154ffd9bb; });
/* cta-with-polygon-background.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $eDoPe = parcelRequire("eDoPe");

var $91nJf = parcelRequire("91nJf");

var $5ohHq = parcelRequire("5ohHq");

var $4XrxY = parcelRequire("4XrxY");
const $86b2c7811891ac1f$var$ctaStyles = null;
const $86b2c7811891ac1f$var$h3Styles = null;
const $86b2c7811891ac1f$var$typographyOverrides = null;
const $86b2c7811891ac1f$var$polygonStyles = null;
const $86b2c7811891ac1f$export$eacf4ba154ffd9bb = ({ header: header, paragraph: paragraph, ctaText: ctaText, ctaUrl: ctaUrl, ctaLabel: ctaLabel, productKey: productKey, backgroundColor: backgroundColor = "#101214", buttonVariant: buttonVariant = "secondary", buttonColor: buttonColor = "white" })=>{
    const { ref: scrollRef, inView: sectionIsVisible } = (0, $eDoPe.useInView)();
    const noParagraphSpacing = !paragraph ? "var(--ds-space-400, 32px)" : 0;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.TypographyStyles), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)("section", {
            ref: scrollRef,
            className: (0, $esG4f.default)([
                "_p12f1git _18s84p42 _y3gn1h6o",
                "_syaz121t _6rth4cqu",
                sectionIsVisible ? "is-visible" : ""
            ]),
            style: {
                "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
            },
            children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                style: {
                    "--background-color": backgroundColor
                },
                className: (0, $esG4f.default)([
                    "_11q76ulk _mkrz1q5k _1vthpg2b _1yt4koci",
                    "polygon"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    layout: "8",
                    children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                                className: (0, $esG4f.default)([
                                    "_1wyb1fu0 _vwz41da2 _1cqs1h67 _1jw853lb _1bys1fu0",
                                    "_syaz121t _6rth4cqu",
                                    "header h3"
                                ]),
                                style: {
                                    marginBottom: noParagraphSpacing,
                                    "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                                },
                                children: header
                            }),
                            paragraph && /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                                layout: "8",
                                children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                    className: (0, $esG4f.default)([
                                        "_syaz121t _6rth4cqu",
                                        ".body-lg"
                                    ]),
                                    style: {
                                        "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                                    },
                                    children: paragraph
                                })
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
                                variant: buttonVariant,
                                color: buttonColor,
                                colorAgainst: backgroundColor == "#101214" ? "black" : "other",
                                href: ctaUrl,
                                dataEventProps: {
                                    "data-product-key": productKey,
                                    "data-event": "clicked",
                                    "data-event-component": "linkButton",
                                    "data-event-container": "ctaSection",
                                    "data-label-english": ctaLabel
                                },
                                className: (0, $esG4f.default)([
                                    "_6rthzwfg"
                                ]),
                                children: ctaText
                            })
                        ]
                    })
                })
            })
        })
    });
};

});

parcelRegister("4Bezw", function(module, exports) {
$parcel$export(module.exports, "TabsWithCards", function () { return (parcelRequire("g5uJU")).TabsWithCards; });
parcelRequire("g5uJU");

});
parcelRegister("g5uJU", function(module, exports) {

$parcel$export(module.exports, "TabsWithCards", function () { return $bc1fe4aca38ac20e$export$3c855d4d211f5f7e; });
/* tabs-with-cards.pattern.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");
parcelRequire("iSvIT");

var $cutM5 = parcelRequire("cutM5");

var $5ohHq = parcelRequire("5ohHq");

var $4XrxY = parcelRequire("4XrxY");
const $bc1fe4aca38ac20e$var$Tab = ({ title: title, isSelected: isSelected, dataEventProps: dataEventProps })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("button", (0, $6iHNw._)((0, $7Knp0._)({}, dataEventProps), {
        className: (0, $esG4f.default)([
            "_1ul9ymf6 _bfhk17fj _4cvr1h6o _1bah1h6o _vchhusvi _1e0c1txw _y3gn1h6o _4bfu1r31 _1hmsglyw _ajmmnqa1 _4t3i12am _2rko1f4h _y4ti1ul9 _bozg1ul9 _80omtlke _19it1hmt _ect4lnmy _k48p1nn1 _1wybgktf _1dbzzucj _1bg41b66 _nt751hlo",
            isSelected && "_19it8djs _bfhk1ybm"
        ]),
        style: {
            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
            "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue")),
            "--_1hkddbi": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue100"))
        },
        children: title
    }));
};
const $bc1fe4aca38ac20e$export$3c855d4d211f5f7e = ({ h2Text: h2Text, tabsData: tabsData })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        id: "tabs",
        className: (0, $esG4f.default)([
            "_1bsb1osq"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $cutM5.Adg4Tabs), {
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    layout: "8",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                        className: (0, $esG4f.default)([
                            "_1bsb1osq _y3gn1h6o _6rthidpf"
                        ]),
                        children: h2Text
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $cutM5.Adg4DraggableTabList), {
                    rowGap: "12px",
                    className: (0, $esG4f.default)([
                        "_ca0q1ylp _u5f31wqb _n3td1qjk _19bv1wqb _1kmx1ylp _1ggmzwfg _1ykz1ul9 _1maezwfg",
                        "tab-list"
                    ]),
                    children: tabsData.map((tab, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $cutM5.Adg4DraggableTab), {
                            tabIndex: index,
                            className: "round-tab",
                            children: /*#__PURE__*/ (0, $loA2J.jsx)($bc1fe4aca38ac20e$var$Tab, {
                                title: tab.title,
                                dataEventProps: {
                                    "data-product-key": "home",
                                    "data-event": "clicked",
                                    "data-event-component": "button",
                                    "data-event-container": "tabsMenu",
                                    "data-label": tab.title,
                                    "data-label-english": tab.englishLabel
                                }
                            })
                        }, index))
                }),
                tabsData.map((tab, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $cutM5.Adg4TabPanel), {
                        panelIndex: index,
                        id: tab.id,
                        children: tab.tabComponent
                    }, index))
            ]
        })
    });
};
const $bc1fe4aca38ac20e$var$sectionStyles = null;
const $bc1fe4aca38ac20e$var$h2Styles = null;
const $bc1fe4aca38ac20e$var$tabList = null;
const $bc1fe4aca38ac20e$var$tabStyles = null;
const $bc1fe4aca38ac20e$var$currentStyle = null;

});


parcelRegister("efepR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cef5c4644cdf7bf7$export$2e2bcd8739ae039; });
/* tabs-content.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $iSvIT = parcelRequire("iSvIT");

var $vqrsL = parcelRequire("vqrsL");

var $bhreu = parcelRequire("bhreu");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");

var $4XrxY = parcelRequire("4XrxY");

var $aOuDE = parcelRequire("aOuDE");
const $cef5c4644cdf7bf7$var$settings = {
    arrows: false,
    centerMode: true,
    dots: true,
    infinite: false,
    swipeToSlide: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
}; // Source https://github.com/kenwheeler/slick/blob/master/slick/slick.css
// FIXME: Nested selectors are used here to target dynamically inserted child elements
const $cef5c4644cdf7bf7$var$slickStyle = null;
const $cef5c4644cdf7bf7$var$TabsContent = (tabsContentProps)=>{
    var _tabsContentProps_contentLink, _tabsContentProps_contentLink1, _tabsContentProps_contentLink2;
    const isMobile = (0, $aOuDE.useIsMobile)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.TypographyStyles), {
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_y44v951u",
                tabsContentProps.className || ""
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_dm2511p5 _1rqtaigu _pdlmzwfg"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                className: (0, $esG4f.default)([
                                    "_uhi5kb7n _eao7qfx8"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                        className: (0, $esG4f.default)([
                                            "_kzvi1txw _1gzvzwfg",
                                            "content-list"
                                        ]),
                                        children: tabsContentProps.contentList.map((content, index)=>/*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                                className: (0, $esG4f.default)([
                                                    "_xlt17vkz _40tuftgi _1tnt1tcg _v9tzum4z _p6svglyw",
                                                    "content-text"
                                                ]),
                                                style: {
                                                    "--_r91gx3": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light400"))
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                                                        className: (0, $esG4f.default)([
                                                            "_6rthidpf _1pfhidpf",
                                                            content === null || content === void 0 ? void 0 : content.headerType
                                                        ]),
                                                        children: content.headerText
                                                    }),
                                                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                                        className: (0, $esG4f.default)([
                                                            "_476dftgi"
                                                        ]),
                                                        children: content.bodyText
                                                    })
                                                ]
                                            }, "content-" + index))
                                    }),
                                    tabsContentProps.contentLink && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                        className: (0, $esG4f.default)([
                                            "_gq9a1h6o",
                                            "link-content-container"
                                        ]),
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                                            href: tabsContentProps.contentLink.link,
                                            text: (_tabsContentProps_contentLink = tabsContentProps.contentLink) === null || _tabsContentProps_contentLink === void 0 ? void 0 : _tabsContentProps_contentLink.linkText,
                                            type: "primary",
                                            dataEventProps: {
                                                "data-product-key": (_tabsContentProps_contentLink1 = tabsContentProps.contentLink) === null || _tabsContentProps_contentLink1 === void 0 ? void 0 : _tabsContentProps_contentLink1.productKey,
                                                "data-event": "clicked",
                                                "data-event-component": "linkButton",
                                                "data-event-container": "tabsSection",
                                                "data-label-english": (_tabsContentProps_contentLink2 = tabsContentProps.contentLink) === null || _tabsContentProps_contentLink2 === void 0 ? void 0 : _tabsContentProps_contentLink2.linkLabel
                                            }
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_1reo15vq _18m915vq _uhi5qfx8 _eao71mrw _1iyegktf"
                                ]),
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), (0, $6iHNw._)((0, $7Knp0._)({}, tabsContentProps.pictureProps), {
                                    className: (0, $esG4f.default)([
                                        "_rtys1osq _1jpx1f51 _mezj1osq _1oo31q9y _bna71wug _m369951u _ovn1i2wt"
                                    ])
                                }))
                            })
                        ]
                    })
                }),
                tabsContentProps.tabContentEyebrowText && /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: "tab-content-header-wrapper",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                            className: (0, $esG4f.default)([
                                "_y3gn1h6o _1pfhidpf _6rth1tcg",
                                "eyebrow-md"
                            ]),
                            children: tabsContentProps.tabContentEyebrowText
                        })
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: "tabs-content-cards",
                    children: isMobile ? /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_vnijh2mm _1ls01ule _1dtvusvi _1kb1glyw _fjwtglyw _1wv2glyw _1r6vglyw _zookglyw _8rkdglyw _1tpbmuzh _u8dlmuzh _e1ct1j28 _1t25h2mm _8lsh15vq _kuv715vq _19moidpf _1vqqidpf _m8oxidpf _bzd2idpf _snlxh2mm _1rfpidpf _104oidpf _j6fg1ule _gkdh1wug _1jbo1wug _1t4e15vq _1u35glyw _1vrb1e5h _m8yv1osq _11wpftgi _ehjsftgi _13e4ftgi _12l3ftgi _gzcot94y _1xnx1ule _6rj8idpf _k58e13la _qmn3idpf _bjmnidpf _6qh814y2 _1qzl14y2 _1dx414y2 _1n6c14y2 _1mfj1h6o _12bq1o8l _nog6tlke _1njogktf _1ssvgktf _110yidpf _1glb14y2 _1a57idpf _c30z14y2 _1yjcidpf _qop8idpf _63deidpf _l4aeidpf _1jkiidpf _1xco1ule _je42idpf _176uidpf _rtji14y2 _1jth14y2 _9af414y2 _9uha14y2 _11votlke _omsfgktf _6fzegktf _5l3c1j28 _iygb1j28 _c2ls1r31 _6ejeglyw _1e79idpf _54up1hlo _1gdw1osq _cshx1hlo _2g951ssb _1f1o1mp2 _z3otldb6 _w1ixgktf _1kauidpf _fcd11h6o _slqlidpf _4if1gktf _vcsd13la _1wxl1h6o"
                        ]),
                        style: {
                            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                        },
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($vqrsL))), (0, $6iHNw._)((0, $7Knp0._)({}, $cef5c4644cdf7bf7$var$settings), {
                            children: tabsContentProps.cardsContent.map((cardContent, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, {
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)($cef5c4644cdf7bf7$var$TabCard, (0, $7Knp0._)({}, cardContent))
                                }, "card-" + index))
                        }))
                    }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                        layout: "4-4-4",
                        containerType: "ul",
                        children: tabsContentProps.cardsContent.map((cardContent, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, {
                                children: /*#__PURE__*/ (0, $loA2J.jsx)($cef5c4644cdf7bf7$var$TabCard, (0, $6iHNw._)((0, $7Knp0._)({}, cardContent), {
                                    containerType: "li"
                                }))
                            }, "card-" + index))
                    })
                })
            ]
        })
    });
};
const $cef5c4644cdf7bf7$var$slidein = null;
const $cef5c4644cdf7bf7$var$wrapperStyles = null;
const $cef5c4644cdf7bf7$var$bigImgWrapperStyles = null;
const $cef5c4644cdf7bf7$var$contentListWrapperStyle = null;
const $cef5c4644cdf7bf7$var$contentListTextWrapperStyle = null;
const $cef5c4644cdf7bf7$var$contentListStyles = null;
const $cef5c4644cdf7bf7$var$contentImageStyle = null;
const $cef5c4644cdf7bf7$var$eyebrowStyle = null;
const $cef5c4644cdf7bf7$var$ContentTextStyles = null;
const $cef5c4644cdf7bf7$var$ContentTextPStyle = null;
const $cef5c4644cdf7bf7$var$contentListHeaderStyle = null;
const $cef5c4644cdf7bf7$var$linkContainerStyle = null;
const $cef5c4644cdf7bf7$var$TabCard = (cardContentProps)=>{
    const { eyebrowText: eyebrowText, headerText: headerText, bodyText: bodyText, ctaProps: ctaProps, pictureProps: pictureProps, containerType: containerType } = cardContentProps;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Card), {
        title: headerText,
        titleAs: "h3",
        image: pictureProps,
        body: bodyText,
        eyebrow: eyebrowText,
        callToAction: ctaProps,
        containerType: containerType
    });
};
var $cef5c4644cdf7bf7$export$2e2bcd8739ae039 = $cef5c4644cdf7bf7$var$TabsContent;

});

parcelRegister("bwE7U", function(module, exports) {

$parcel$export(module.exports, "EnterprisePageProductNav", function () { return $3f60c9aa58855bbf$export$e36ad2737327f9c; });
$parcel$export(module.exports, "default", function () { return $3f60c9aa58855bbf$export$2e2bcd8739ae039; });
/* enterprise-nav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $dyZbY = parcelRequire("dyZbY");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");

var $cP0Yq = parcelRequire("cP0Yq");
const $3f60c9aa58855bbf$var$logoWrapperStyles = null;
const $3f60c9aa58855bbf$var$EnterpriseLogo = ()=>/*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1q51v77o _4t3i1osq"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Logo), {
            brand: "enterprise",
            type: "logo",
            appearance: "brand"
        })
    });
const $3f60c9aa58855bbf$export$e36ad2737327f9c = ({ isActive: isActive })=>{
    const intl = (0, $f6qj2.default)();
    const ctaButtonText = intl.formatMessage({
        id: "EnterpriseLandingPage.navbar.cta",
        defaultMessage: "Contact sales"
    });
    const mobileCtaButtonText = intl.formatMessage({
        id: "EnterpriseLandingPage.navbar.mobile.cta",
        defaultMessage: "Contact sales"
    });
    const links = [
        {
            globalLinksKey: "overview",
            linkText: intl.formatMessage({
                id: "EnterpriseLandingPage.navbar.overview",
                defaultMessage: "Overview"
            }),
            hasSubnav: false,
            isActive: isActive == "overview",
            productKey: "enterprise",
            href: (0, $3FBn4.useLocalizedHref)("/enterprise")
        },
        {
            globalLinksKey: "success",
            linkText: intl.formatMessage({
                id: "EnterpriseLandingPage.navbar.success",
                defaultMessage: "Success"
            }),
            hasSubnav: false,
            isActive: isActive == "success",
            productKey: "enterprise",
            href: (0, $3FBn4.useLocalizedHref)("/enterprise/success")
        },
        {
            globalLinksKey: "resources",
            linkText: intl.formatMessage({
                id: "EnterpriseLandingPage.navbar.resources",
                defaultMessage: "Resources"
            }),
            hasSubnav: false,
            isActive: isActive == "resources",
            productKey: "enterprise",
            href: (0, $3FBn4.useLocalizedHref)("/enterprise/resources")
        }
    ];
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "enterprise-page-product-navigation",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cP0Yq.ProductPageSubNav), {
            productLogoUrl: (0, $3FBn4.useLocalizedHref)("/enterprise"),
            productLogo: /*#__PURE__*/ (0, $loA2J.jsx)($3f60c9aa58855bbf$var$EnterpriseLogo, {}),
            productLogoAriaLabel: intl.formatMessage({
                id: "EnterpriseLandingPage.label",
                defaultMessage: "Enterprise"
            }),
            mobileLogo: /*#__PURE__*/ (0, $loA2J.jsx)($3f60c9aa58855bbf$var$EnterpriseLogo, {}),
            productPageNavLinks: links,
            mobileLinksSections: [
                {
                    mobileLinkKey: "mobile-enterprise",
                    mobileLinksProps: links
                }
            ],
            navigationTrynowCtaText: ctaButtonText,
            navigationTrynowCtaUrl: (0, $3FBn4.useLocalizedHref)("/enterprise/contact?formType=product-features"),
            mobileCtaText: mobileCtaButtonText,
            mobileCtaUrl: (0, $3FBn4.useLocalizedHref)("/enterprise/contact?formType=product-features")
        })
    });
};
var $3f60c9aa58855bbf$export$2e2bcd8739ae039 = $3f60c9aa58855bbf$export$e36ad2737327f9c;

});

parcelRegister("ae9Z5", function(module, exports) {

$parcel$export(module.exports, "ConsentHubClientConfigProvider", function () { return $884ddbc337da1280$export$4f1d572ab3f4c2e6; });
$parcel$export(module.exports, "useConsentHubClientConfig", function () { return $884ddbc337da1280$export$ef2475d0eafefa1b; });
//@ts-nocheck

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $gkhN4 = parcelRequire("gkhN4");
const $884ddbc337da1280$var$requiredProps = [
    "email",
    "site",
    "locale",
    "formUrl"
];
const $884ddbc337da1280$var$defaultLocaleConfig = {
    locale: "UNKNOWN",
    localeRequiresMarketingCommunicationOptIn: true
};
const $884ddbc337da1280$export$ff156a5e09be2a6a = async (stargateClient)=>{
    return await stargateClient.getConsentConfig().then((response)=>response, (err)=>{
        return $884ddbc337da1280$var$defaultLocaleConfig;
    });
};
const $884ddbc337da1280$export$7bb3e177c1a1e841 = async (stargateClient, params, localeConfig)=>{
    const paramsLocale = params.paramsLocale ? params.paramsLocale : "UNKNOWN";
    const postData = (0, $7Knp0._)({
        locale: localeConfig.locale || paramsLocale
    }, params);
    if (!$884ddbc337da1280$var$requiredProps.every((prop)=>postData.hasOwnProperty(prop))) throw `Invalid parameters. Required: {${$884ddbc337da1280$var$requiredProps.toString()}}`;
    const updateConsentPreferencesResponseStatus = await stargateClient.updateConsentPreferences(postData);
    return updateConsentPreferencesResponseStatus;
};
const $884ddbc337da1280$var$useGetConsentConfig = ()=>{
    const stargateClient = (0, $gkhN4.useBxpWebStargateClient)();
    const [localeConfig, setLocaleConfig] = (0, $iSvIT.useState)($884ddbc337da1280$var$defaultLocaleConfig);
    (0, $iSvIT.useEffect)(()=>{
        const fetchConfigData = async ()=>{
            const consentHubConfig = await $884ddbc337da1280$export$ff156a5e09be2a6a(stargateClient);
            if (consentHubConfig) setLocaleConfig(consentHubConfig);
        };
        fetchConfigData().catch((err)=>console.log(err));
    }, [
        stargateClient
    ]);
    return [
        localeConfig
    ];
};
const $884ddbc337da1280$export$6ccd5662e539f2b6 = /*#__PURE__*/ (0, $iSvIT.createContext)($884ddbc337da1280$var$defaultLocaleConfig);
const $884ddbc337da1280$export$4f1d572ab3f4c2e6 = ({ children: children })=>{
    const [localeConfig] = $884ddbc337da1280$var$useGetConsentConfig();
    return /*#__PURE__*/ (0, $loA2J.jsx)($884ddbc337da1280$export$6ccd5662e539f2b6.Provider, {
        value: localeConfig,
        children: children
    });
};
const $884ddbc337da1280$export$ef2475d0eafefa1b = ()=>{
    const context = (0, $iSvIT.useContext)($884ddbc337da1280$export$6ccd5662e539f2b6);
    if (!context) throw new Error("useConsentHubClientConfig must be used within a ConsentHubClientConfigProvider");
    return context;
};

});

parcelRegister("28Po9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74c3a029b02b232c$export$2e2bcd8739ae039; });
/* resource-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $bQawl = parcelRequire("bQawl");
const $74c3a029b02b232c$var$resourceCardStyles = {
    primary: {
        white: {
            padding: "24px",
            borderStyle: "solid",
            borderWidth: "1px",
            borderRadius: "10px",
            borderColor: "#c1c7d0",
            width: "310px"
        },
        grey: {
            height: "100%",
            padding: "40px",
            backgroundColor: "#fafbfc",
            borderRadius: "3px"
        }
    },
    secondary: {}
};
const $74c3a029b02b232c$var$wrapperStyle = null;
const $74c3a029b02b232c$var$headerStyle = null;
const $74c3a029b02b232c$var$descriptionStyle = null;
const $74c3a029b02b232c$var$buttonStyle = null;
const $74c3a029b02b232c$var$ResourceCard = ({ header: header, description: description, buttonText: buttonText, url: url, type: type, color: color })=>{
    const formattedType = type === null || type === void 0 ? void 0 : type.toLowerCase();
    const resourceCardType = formattedType === "secondary" ? "secondary" : "primary";
    const formattedColor = color === null || color === void 0 ? void 0 : color.toLowerCase();
    const resourceCardColor = formattedColor === "grey" ? "grey" : "white";
    const styles = $74c3a029b02b232c$var$resourceCardStyles[resourceCardType][resourceCardColor]; /* eslint-disable @typescript-eslint/no-non-null-assertion */ 
    const { padding: padding, width: width, height: height, borderStyle: borderStyle, borderRadius: borderRadius, borderWidth: borderWidth, borderColor: borderColor, backgroundColor: backgroundColor } = styles ? styles : $74c3a029b02b232c$var$resourceCardStyles.primary.white; /* eslint-enable @typescript-eslint/no-non-null-assertion */ 
    const backgroundStyle = null;
    const templatesTabCardDataEventProps = {
        "data-product-key": "enterpriseContactSales",
        "data-event-component": "linkButton",
        "data-event-container": "cardSection",
        "data-event": "clicked"
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_kqswh2mm _vchhusvi _1e0c1ule _1aax1e5h _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _1tket94y _ect4czdy _1wyb7vkz _vwz47vkz _s7n41q9y _14b527ks"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_vchhusvi _1e0c1ule _2lx21bp4 _1yt418y6 _1bsb9tg7 _4t3imry4 _1dqo1yif _2rko1qt3 _189e1ywc _bfhkaxbu _1h6d1srq"
            ]),
            style: {
                "--_1xumd0e": (0, $43MIc.default)(padding),
                "--_1ea5ebz": (0, $43MIc.default)(width),
                "--_roksyz": (0, $43MIc.default)(height),
                "--_ahoyl5": (0, $43MIc.default)(borderStyle),
                "--_1lnby5": (0, $43MIc.default)(borderRadius),
                "--_g1hsiq": (0, $43MIc.default)(borderWidth),
                "--_1ly4823": (0, $43MIc.default)(backgroundColor),
                "--_37cwmb": (0, $43MIc.default)(borderColor)
            },
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_vchhusvi _1e0c1ule _6rth1tcg _ect418zh _1wyb1k92 _k48pbfng _1dyz165v _vwz4cjiy _s7n41q9y _syaz1bqd _qtemdlk8 _1cqs1j6v _srwzdlk8 _1bys10nf"
                    ]),
                    children: header
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_vchhusvi _1e0c1ule _6rth1tcg _ect4czdy _1wyb7vkz _k48p1nn1 _vwz4bs82 _syazvwuj _s7n41q9y"
                    ]),
                    children: description
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bQawl.default), {
                        text: buttonText,
                        "aria-label": buttonText,
                        url: url,
                        type: "secondary",
                        color: "whiteblue",
                        dataEventProps: templatesTabCardDataEventProps,
                        className: (0, $esG4f.default)([
                            "_bfhku67f _syazrbzz _vchhusvi _1e0c1o8l _4t3in7od _1tkel07h _85i56mu8 _bozg19bv _y4ti19bv _1q516mu8 _ect418gv _1wyboxwj _k48pbfng _vwz4nqt0 _y3gn1h6o _1hmsglyw _ajmmnqa1 _1keg1wug _3fcw1g80 _s7n41q9y _d5ymcfaq _1dqonqa1 _189et94y _80omtlke _2rko1l7b _qmxj15zi _1y1musvi _qjkj1u8q _1lrw1wug"
                        ])
                    })
                })
            ]
        })
    });
};
var $74c3a029b02b232c$export$2e2bcd8739ae039 = $74c3a029b02b232c$var$ResourceCard;

});


var $f788Q = parcelRequire("f788Q");

var $cbOuC = parcelRequire("cbOuC");
(0, $f788Q.init)((0, $cbOuC.EnterpriseContactSalesPage));


//# sourceMappingURL=enterprise-contact-sales-page.48782dd4.js.map
